import { Directive, input, output } from "@angular/core";
import { ValidationErrors } from "@angular/forms";

// Abstract base class that can be implemented by any component that adds new item (to a parent component, for example)
// NIT: The type of new items that are added
@Directive()
export abstract class ItemEditor<NIT> {
	readonly placeholder = input<string>();

	readonly cancelled = output<void>();

	readonly submitted = output<NIT>();

	readonly focusLost = output<void>();

	customErrors: ValidationErrors = {};

	abstract focus(): void;

	abstract cancel(): void;

	onChange(): void {
		this.customErrors = {};
	}

	hasCustomErrors(): boolean {
		return Object.keys(this.customErrors).length > 0;
	}
}
